import { isPopDevToolsEnabled } from '../enabled';
import { installErrorsTap } from './errors-tap';
import { installIpcReceiveTap } from './ipc-tap';
import { installMainRelayTap } from './main-relay-tap';
import { installPopH264Tap } from './poph264-tap';

type IpcReceiveRegistrar = (callback: (type: any, ...handlerArgs: any[]) => void | symbol) => () => void;

let initialized = false;
let ipcInitialized = false;
let stashedIpcRegistrar: IpcReceiveRegistrar | undefined;

export const initializePopDevToolsTaps = () => {
  if (initialized || !isPopDevToolsEnabled()) return;
  initialized = true;

  installErrorsTap();
  installPopH264Tap();
};

export const initializePopDevToolsIpcTaps = (registerIpcReceiveCallback: IpcReceiveRegistrar) => {
  // Stash before the enabled check so a later runtime opt-in can install the
  // IPC taps without re-plumbing the registrar (see runtime-opt-in.ts).
  stashedIpcRegistrar = registerIpcReceiveCallback;
  if (ipcInitialized || !isPopDevToolsEnabled()) return;
  ipcInitialized = true;

  installMainRelayTap(registerIpcReceiveCallback);
  installIpcReceiveTap(registerIpcReceiveCallback);
};

export const reinitializePopDevToolsIpcTaps = () => {
  if (stashedIpcRegistrar) initializePopDevToolsIpcTaps(stashedIpcRegistrar);
};
